/* eslint-disable react/no-danger */
/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import moment from 'moment';
import { actions } from '../../actions/publicSurveyActions';
import { actions as authActions } from '../../actions/authActions';
import LoadingIndicator from '../LoadingIndicator';
import UserInfoPanel from '../auth/UserInfoPanel';

class PublicSurveySubmissionVerificationPage extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.actions.getDetails(this.props.match.params.id);
    this.props.actions.verifySurveySubmission(this.props.match.params.id, this.props.match.params.submissionId);
  }

  render() {
    const { fetching, survey, account, auth, verificationResult } = this.props;
   
    return (
      <div style={{ padding: 16, marginBottom: 400 }}>
        <LoadingIndicator fetching={fetching}>
          {survey &&
            <React.Fragment>
              <div className="row top">
                <div className="col-sm-2" />
                <div className="col-sm-3" />
                <div className="col-sm-7 header">
                  {survey.authenticationRequired || survey.boardSettings.enabled || (auth && auth.signedIn) ? <UserInfoPanel auth={auth}
                    authenticationRequired={survey.authenticationRequired} authActions={this.props.authActions} account={account} /> : null}
                  <a href="/konsultacje-spoleczne" className="btn"><i className="fa fa-long-arrow-alt-left" /> lista konsultacji</a>
                </div>
              </div>

              <div>
                <div className="row">
                  <div className="box">
                    <div className="col-sm-12">
                      <h2>{survey.name}</h2>
                      <ul className="date">
                        {survey.activeFrom && <li className="date_from"><i className="far fa-clock" /> <span>Data rozpoczęcia</span> {moment(survey.activeFrom).format('D MMMM YYYY HH:mm')}</li>}
                        {survey.activeTo && <li className="date_to"><i className="far fa-clock" /> <span>Data zakończenia</span> {moment(survey.activeTo).format('D MMMM YYYY HH:mm')}</li>}
                      </ul>
                      <div style={{ textAlign: 'center' }}>
                        {verificationResult
                          ? <h3>Twój głos został prawidłowo zweryfikowany</h3>
                          : <h3 style={{ color: 'red' }}>Głos został już zweryfikowany lub ankieta nie jest już aktywna</h3>}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>}
        </LoadingIndicator>
      </div>
    );
  }
}

PublicSurveySubmissionVerificationPage.propTypes = {
  t: PropTypes.func.isRequired,
  actions: PropTypes.object.isRequired,
  authActions: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  fetching: PropTypes.bool.isRequired,
  survey: PropTypes.object,
  userSignedIn: PropTypes.bool,
  auth: PropTypes.object,
  account: PropTypes.object,
  verificationResult: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    fetching: state.publicSurveyDetails.fetching || state.publicSurveyVerification.fetching,
    survey: state.publicSurveyDetails.data,
    verificationResult: state.publicSurveyVerification.ok,
    userSignedIn: state.auth.signedIn,
    auth: state.auth,
    account: state.account.data,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    authActions: bindActionCreators(authActions, dispatch),
  };
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate()
)(PublicSurveySubmissionVerificationPage);



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/PublicSurveySubmissionVerificationPage.js